import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import AuroraBackground from './AuroraBackground';
import PushNotificationPrompt from './PushNotificationPrompt';
import WhatsAppButton from './WhatsAppButton';
import Footer from './Footer';

function AppShell() {
  const { pathname } = useLocation();
  const showAurora = !pathname.startsWith('/l/');

  return (
    <>
      {showAurora && <AuroraBackground />}
      <Box sx={{ position: 'relative', zIndex: 1, minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ flex: 1 }}>
          <Outlet />
        </Box>
        <Footer />
      </Box>
      <PushNotificationPrompt />
      <WhatsAppButton />
    </>
  );
}

export default AppShell;
